import { Component, Input } from '@angular/core';
import { Produto } from 'src/app/core/models/produto.model';

@Component({
  selector: 'app-pedido-atacado',
  templateUrl: './pedido-atacado.component.html',
  styleUrls: ['./pedido-atacado.component.scss']
})
export class PedidoAtacadoComponent {
  @Input() servicosAdicionados: Produto[] = [];
  @Input() codLoja: number | undefined;
  @Input() codCliente: number | undefined;
}
